import { createContext } from "react";

import { useNonNullableContext } from "app/common";

type TrafficSourceTabsContextValue = [selectedIndex: number, setSelectedIndex: (current: number) => void];

export const TrafficSourceTabsContext = createContext<TrafficSourceTabsContextValue | null>(null);
TrafficSourceTabsContext.displayName = "TrafficSourceTabsContext";

export const useTrafficSourceTabsContext = () => useNonNullableContext(TrafficSourceTabsContext);
